export const ROCKSPOON_WEBSITE_URL = 'https://www.rockspoon.com/';
